import type { ModalFunc, ModalFuncProps } from 'ant-design-vue/lib/modal/Modal';

import { Modal, message as Message, notification } from 'ant-design-vue';
import { InfoCircleFilled, CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons-vue';
// import { SvgIcon } from '/@/components/Icon';

import { NotificationArgsProps, ConfigProps } from 'ant-design-vue/lib/notification';
import { isString } from '/@/utils/is';

export interface NotifyApi {
  info(config: NotificationArgsProps): void;
  success(config: NotificationArgsProps): void;
  error(config: NotificationArgsProps): void;
  warn(config: NotificationArgsProps): void;
  warning(config: NotificationArgsProps): void;
  open(args: NotificationArgsProps): void;
  close(key: String): void;
  config(options: ConfigProps): void;
  destroy(): void;
}

export declare type NotificationPlacement = 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
export declare type IconType = 'success' | 'info' | 'error' | 'warning';
export interface ModalOptionsEx extends Omit<ModalFuncProps, 'iconType'> {
  iconType?: 'warning' | 'success' | 'error' | 'info' | 'empty';
}
export type ModalOptionsPartial = Partial<ModalOptionsEx> & Pick<ModalOptionsEx, 'content'>;

interface ConfirmOptions {
  info: ModalFunc;
  success: ModalFunc;
  error: ModalFunc;
  warn: ModalFunc;
  warning: ModalFunc;
}

function getIcon(iconType: string) {
  if (iconType === 'warning') {
    // return (
    //   <span class="anticon modal-icon-warning">
    //     <SvgIcon name="icon-warning" class="modal-icon-warning" size="24" color="#FDB022" />
    //   </span>
    // );
    return <InfoCircleFilled class="modal-icon-warning" />;
  } else if (iconType === 'success') {
    // return (
    //   <span class="anticon modal-icon-success">
    //     <SvgIcon name="icon-success" class="modal-icon-success" size="24" color="#32D583" />
    //   </span>
    // );
    return <CheckCircleFilled class="modal-icon-success" />;
  } else if (iconType === 'info') {
    // return (
    //   <span class="anticon modal-icon-info">
    //     <SvgIcon name="icon-info" class="modal-icon-info" size="24" color="#57CCEF" />
    //   </span>
    // );
    return <InfoCircleFilled class="modal-icon-info" />;
  } else if (iconType === 'error') {
    // return (
    //   <span class="anticon modal-icon-error">
    //     <SvgIcon name="icon-error" class="modal-icon-error" size="24" color="#F97066" />
    //   </span>
    // );
    return <CloseCircleFilled class="modal-icon-error" />;
  } else if (iconType === 'close') {
    // return (
    //   <span class="anticon modal-icon-error">
    //     <SvgIcon name="icon-error" class="modal-icon-error" size="24" color="#F97066" />
    //   </span>
    // );
    return <CloseCircleFilled class="modal-icon-error" />;
  } else {
    return <span></span>;
  }
}

function renderContent({ content }: Pick<ModalOptionsEx, 'content'>) {
  if (isString(content)) {
    return <div innerHTML={`<div>${content as string}</div>`}></div>;
  } else {
    return content;
  }
}

/**
 * @description: Create confirmation box
 * 如果需要边框，但里面内容只有一句话，可以传 class: 'confirm-border'
 * 不传 iconType 则没有图标
 */
function createConfirm(options: ModalOptionsEx): ConfirmOptions {
  const iconType = options?.iconType || 'empty';
  Reflect.deleteProperty(options, 'iconType');
  const opt: ModalFuncProps = {
    centered: true,
    icon: getIcon(iconType),
    ...options,
    content: renderContent(options),
  };
  return Modal.confirm(opt) as unknown as ConfirmOptions;
}

function createModalOptions(options: ModalOptionsPartial, icon: string): ModalOptionsPartial {
  return {
    // ...getBaseOptions(),
    ...options,
    content: renderContent(options),
    icon: getIcon(icon),
  };
}

function createSuccessModal(options: ModalOptionsPartial) {
  return Modal.success(createModalOptions(options, 'success'));
}

function createErrorModal(options: ModalOptionsPartial) {
  return Modal.error(createModalOptions(options, 'close'));
}

function createInfoModal(options: ModalOptionsPartial) {
  return Modal.info(createModalOptions(options, 'info'));
}

function createWarningModal(options: ModalOptionsPartial) {
  return Modal.warning(createModalOptions(options, 'warning'));
}

notification.config({
  placement: 'topRight',
  duration: 3,
});
// message count
Message.config({ maxCount: 1 });

/**
 * @description: message
 */
export function useMessage() {
  return {
    createMessage: Message,
    notification: notification as NotifyApi,
    createConfirm: createConfirm,
    createSuccessModal,
    createErrorModal,
    createInfoModal,
    createWarningModal,
  };
}
